import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import { ReadLess, ReadMore } from 'autogen/translation-keys/trans-website-shared-buttons';
import InlineButton from 'components/generic/InlineButton';
import type { TypeTextDetailed } from 'types/autogen/contentful';
import RichText from './shared/RichText';

const CollapsedContainer = styled.div<{ $collapsed: boolean }>`
    ${({ $collapsed }) =>
        $collapsed
            ? css`
                position: relative;
                max-height: 6.85rem;
                overflow: hidden;
                mask-image: linear-gradient(to bottom, #ffffff 0%, transparent 100%); 
            `
            : css`
                margin-bottom: ${({ theme }) => theme.Spacing8};   
            `}
`;

export default function Text(props: TypeTextDetailed) {
    const {
        fields: { richText, collapseText },
        sys: { id }
    } = props;
    if (!richText) return;
    const inspectorProps = useContentfulInspectorMode({ entryId: id });
    const [collapsedValue, setCollapsedValue] = useState(!!collapseText);
    const { t } = useTranslation();

    if (collapseText) {
        return (
            <div {...inspectorProps({ fieldId: 'richText' })}>
                <CollapsedContainer $collapsed={collapsedValue}>
                    <RichText {...richText} />
                </CollapsedContainer>

                <InlineButton
                    fontWeight="semibold"
                    onClick={() => {
                        setCollapsedValue((prev) => !prev);
                    }}
                >
                    {collapsedValue ? t(ReadMore) : t(ReadLess)}
                </InlineButton>
            </div>
        );
    }

    return (
        <div {...inspectorProps({ fieldId: 'richText' })}>
            <RichText {...richText} />
        </div>
    );
}
